var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-play",
    clipPath: "url(#clip0_2522_9381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.00016 17.3337H12.0002C12.9207 17.3337 13.6668 16.5875 13.6668 15.667V5.52399C13.6668 5.08191 13.4912 4.65799 13.1787 4.34549L9.98833 1.15516C9.67575 0.842576 9.25183 0.666992 8.80983 0.666992H2.00016C1.07966 0.666992 0.333496 1.41316 0.333496 2.33366V15.667C0.333496 16.5875 1.07966 17.3337 2.00016 17.3337ZM8.66683 1.91699H8.80966C8.92116 1.91699 9.02575 1.96049 9.10466 2.03908L12.2947 5.22916C12.3732 5.30808 12.4168 5.41266 12.4168 5.52416V5.66699H10.3335C9.413 5.66699 8.66683 4.92083 8.66683 4.00033V1.91699ZM4.50016 8.96624C4.50016 8.32891 5.3565 7.94883 5.99583 8.30224L9.07183 10.003C9.643 10.3189 9.643 11.015 9.07183 11.3308L5.99583 13.0315C5.3565 13.3851 4.50016 13.0049 4.50016 12.3677V8.96624Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2522_9381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 16.6667,
    fill: "white",
    transform: "translate(0.333496 0.666992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlay);
export default __webpack_public_path__ + "static/media/file-play.fbea10592662040bfd622f653d1f3a3c.svg";
export { ForwardRef as ReactComponent };